"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHIFT_INTERVALS_30_MIN = exports.isValid_30MinTimeSlot = exports.isValidMonth = exports.isValidDay = exports.validate_24HourTime = void 0;
const validate_24HourTime = (timeStr) => {
    const matchingRegex = timeStr.search(/^\d{2}:\d{2}$/) != -1;
    if (matchingRegex) {
        const splittedTime = timeStr.split(':');
        if (parseInt(splittedTime[0]) > 23) {
            return { errorType: 'InvalidHour' };
        }
        if (parseInt(splittedTime[1]) > 59) {
            return { errorType: 'InvalidMinute' };
        }
        return null;
    }
    return { errorType: 'Accepted time format is: HH:MM. Example: 01:06, 21:50' };
};
exports.validate_24HourTime = validate_24HourTime;
const isValidDay = (dayStr) => {
    const validDays = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday',
    ];
    return validDays.includes(dayStr.toLowerCase());
};
exports.isValidDay = isValidDay;
const isValidMonth = (monthStr) => {
    const validMonths = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];
    return validMonths.includes(monthStr.toLowerCase());
};
exports.isValidMonth = isValidMonth;
const isValid_30MinTimeSlot = (timeStr) => {
    return exports.SHIFT_INTERVALS_30_MIN.includes(timeStr);
};
exports.isValid_30MinTimeSlot = isValid_30MinTimeSlot;
exports.SHIFT_INTERVALS_30_MIN = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30',
];
//# sourceMappingURL=validateDateTime.js.map